module.exports = __webpack_public_path__ + "static/media/ajb-two-large-min.cbba0fba.png";


//////////////////
// WEBPACK FOOTER
// ./src/common/images/ajb/ajb-two-large-min.png
// module id = 806
// module chunks = 0